import { useEffect, useCallback } from 'react';
import { useAuth } from './useAuth';
import { timezoneGroupsService } from '../services/timezoneGroups';

export const useAuthenticatedServices = () => {
  const { getToken, isAuthenticated } = useAuth();

  const authTokenGetter = useCallback(async () => {
    if (isAuthenticated) {
      try {
        const token = await getToken({ skipCache: true });
        return token;
      } catch (error) {
        console.error('Failed to get auth token:', error);
        return null;
      }
    }
    return null;
  }, [getToken, isAuthenticated]);

  useEffect(() => {
    // Configure services with auth token getter
    timezoneGroupsService.setAuthTokenGetter(authTokenGetter);
  }, [authTokenGetter]);

  return {
    isAuthenticated
  };
};

export default useAuthenticatedServices;